import { jimoTrackerSetUserData } from '@shared/jimo-tracker-sdk';
import { useGlobalStore, useUserStore } from '@shared/store';

// 初始化 Jimo Tracker 大数据埋点参数
export const initJimoTrackerParams = async () => {
  try {
    const { appData, firstEntryStaffId = '', isAllowProtocol } = useGlobalStore();
    const { userInfo } = useUserStore();
    const { currentCorpId = '' } = appData;
    const {
      openId = '',
      unionId = '',
      mainId = '',
      visitorId = '',
      staffId = '',
      identity = 'SELF',
      customerType = '',
      external_userid = '',
    } = userInfo || {};

    const params = {
      openId,
      unionId,
      userId: visitorId,
      mainId,
      corpId: currentCorpId,
      staffId: firstEntryStaffId || staffId,
      userType: customerType,
      identity,
      parameters: {
        is_allow_protocol: isAllowProtocol ? 0 : 1, // 用户是否同意隐私协议授权 0-同意，1-不同意（为了兼容历史数据，字段值对应的含义相反）
        external_user_id: external_userid || '',
      },
    };

    jimoTrackerSetUserData(params);
  } catch (error) {
    console.log('查询 Jimo Tracker 依赖用户信息出错：', error);
  }
};
